// extracted by mini-css-extract-plugin
export default {"home":"styles_home__aQMvj"};